import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router'
import { useTheme } from '../../../../lib/hooks'

import Button from '@/components/Button'
import ProductDialog from '@/features/Checkout/components/ProductDialog/ProductDialog'
import ScannerIndicator from '@/features/Scanner/ScannerIndicator'
import withScanner from '@/features/Scanner/withScanner'

import useCheckout from '../../hooks/useCheckout'
import Step from '../Step/Step'
import { ButtonList, CartFooter, CartSummaryWrapper, CartTable, CartWrapper } from './Cart.styles'
import CartItem from './CartItem'

const CartSummary = () => {
  const { cartTotal } = useCheckout()
  const { t } = useTranslation()
  const themes = useTheme()

  return (
    <CartSummaryWrapper>
      <h3>{t('totalAmount')}</h3>
      {themes.currency === '€' ? <h2>
        {themes.currency}
        {cartTotal.toFixed(2)}
      </h2> : <h2>
        {cartTotal.toFixed(2)} {themes.currency}
      </h2>}


    </CartSummaryWrapper>
  )
}

const CartActions = () => {
  const { t } = useTranslation()
  const { setCurrentStep, cart } = useCheckout()

  return (
    <>
      <Button disabled={cart.length === 0} block onClick={() => setCurrentStep('PAYMENT')}>
        {t('proceedToPayment')}
      </Button>
    </>
  )
}

const Cart = () => {
  const { cart, reset } = useCheckout()
  const { t } = useTranslation()
  const cartTableRef = useRef(null)
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)

  const onIdle = () => {
    reset()
    navigate('/')
  }

  const idleTimer = useIdleTimer({
    timeout: 1000 * 60,
    promptBeforeIdle: 0,
    onIdle
  })

  useLayoutEffect(() => {
    cartTableRef.current.scrollTo({
      left: 0,
      top: cartTableRef.current.scrollHeight,
      behavior: 'smooth'
    })
    idleTimer.activate()
  }, [cart])

  const handleOpen = () => {
    setOpen(!open)
  }

  return (
    <Step>
      <CartWrapper>
        <CartTable ref={cartTableRef}>
          {cart.map((product, index) => (
            <CartItem key={index} product={product} destination="delete" />
          ))}
          <ScannerIndicator size="small" text={t('scanProduct')} />
          <ButtonList onClick={handleOpen}> {t('addFromList')}</ButtonList>
        </CartTable>
        <CartFooter>
          <CartSummary />
          <CartActions />
        </CartFooter>
      </CartWrapper>
      {open === true && <ProductDialog onClose={() => setOpen(false)} />}
    </Step>
  )
}

export default withScanner(Cart)
